module.exports = __webpack_public_path__ + "static/media/desktop-picture-small.47afd90d.jpeg";